import React, { useState } from 'react';
import { Table } from '../common';
import Paginator from '../common/tables/Paginator';
import OnPremPORequestObject from '../../models/entities/OnPremPORequestObject';
import ApprovalsOnPremObjectsTableRow from './ApprovalsOnPremObjectsTableRow';

interface ApprovalsOnPremObjectsTableProps {
    filteredOnPremObjects: OnPremPORequestObject[];
}

const ApprovalsOnPremObjectsTable = ({
    filteredOnPremObjects,
}: ApprovalsOnPremObjectsTableProps) => {
    const [porsOnPage, setPorsOnPage] = useState<OnPremPORequestObject[]>([]);
    return (
        <Table
            firstColumnAlign='center'
            footer={
                <Paginator
                    data={filteredOnPremObjects}
                    onPageChange={(pors: OnPremPORequestObject[]) => {
                        setPorsOnPage(pors)
                    }}
                />
            }
        >
            <Table.Head>
                <Table.Head.Row>
                    <Table.Head.Cell>Obj Req #</Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>Type</Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>
                        Status
                    </Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>Action</Table.Head.Cell>
                </Table.Head.Row>
            </Table.Head>
            <Table.Body>
                {porsOnPage.map((por: OnPremPORequestObject) => {
                    return <ApprovalsOnPremObjectsTableRow
                        key={por.id}
                        por={por}
                    />;
                }
                )}
            </Table.Body>
        </Table>
    );
}

export default ApprovalsOnPremObjectsTable;